__webpack_public_path__ = '/front_assets/'; // eslint-disable-line

Number.isNaN = Number.isNaN || function isNaNPolyfill(value) {
  return value !== value; // eslint-disable-line no-self-compare
};

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found'); // eslint-disable-line no-console
}
